export class MapInfoItem {
	public title: string;
	public text: string;

	constructor(item: MapInfoItem) {
		this.title = item.title;
		this.text = item.text;
	}
}
